import { useEffect, useState, type CSSProperties, type ReactNode } from "react";

/**
 * Miniatura do produto (Design.md §8.1 / §6.1). Mostra a imagem real da Amazon
 * (Listings `mainImage.link`, servida via /api/v1/inventory) e cai para um
 * placeholder 📦 quando a URL está vazia ou falha ao carregar — assim o operador
 * sempre vê algo identificável, mesmo sem imagem (req 3/5).
 */
export interface ProductImageProps {
  src: string;
  label: string;
  size?: number;
}

export function ProductImage({ src, label, size = 38 }: ProductImageProps): ReactNode {
  const [failed, setFailed] = useState(false);

  // Reseta o estado de erro quando a URL muda (lista reaproveita o componente).
  useEffect(() => {
    setFailed(false);
  }, [src]);

  const box: CSSProperties = {
    width: size,
    height: size,
    flex: "0 0 auto",
    borderRadius: 8,
    background: "var(--panel-alt)",
    overflow: "hidden",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center"
  };

  if (src.length === 0 || failed) {
    return (
      <span
        aria-label={`Imagem indisponível de ${label}`}
        title="Imagem indisponível"
        style={{ ...box, color: "var(--text-faint)", fontSize: Math.round(size * 0.45) }}
      >
        📦
      </span>
    );
  }

  return (
    <span style={box}>
      <img
        src={src}
        alt={label}
        loading="lazy"
        onError={() => setFailed(true)}
        style={{ width: "100%", height: "100%", objectFit: "contain" }}
      />
    </span>
  );
}
